/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacts_Add_Artifact_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to add artifact. Please try again." |
*
* @param {Artifacts_Add_Artifact_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_add_artifact_error = /** @type {((inputs?: Artifacts_Add_Artifact_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Add_Artifact_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Hinzufügen des Artefakts. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to add artifact. Please try again.")
});